import React, { useEffect } from "react"
import Breadcrumb from "../../../shared/components/atoms/breadcrumb/breadcrumb"
import { pushGtagEvent } from "../../../shared/utils/metricManagementUtil"
import { createListProductPayload } from "../../../shared/utils/payloadDatalayer"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import HeaderProduct from "../../molecules/header-product/header-product"
import ProductSection from "../../molecules/product-section/product-section"
import "./product-content.scss"

const ProductContent = ({
  mobile,
  context,
  setModalActive,
  prefijoComentarios,
}) => {
  // dispatch datalayer on load page
  useEffect(() => {
    const userInfoEncrypt= encryptUserInfo()
    const items = createListProductPayload([context.params])

    pushGtagEvent({
      event: "view_item",
      params: {
        items,
        currency: "COP",
        value: 0,
        redemption: "No",
        points: 0,
        user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
        log_status: userInfoEncrypt.log_status,        
      },
    })
  }, [])

  return (
    <div className="f-product-content">
      <div className="f-breadcrum-position">
        <Breadcrumb />
      </div>
      <HeaderProduct
        banner={context.params.bannerDelProducto}
        title={context.params.titulo}
      />
      <ProductSection
        isSecret={
          context.params.codigoDeProducto &&
          context.params.codigoDeProducto.includes("SECRET")
        }
        mobile={mobile}
        prefijoComentarios={prefijoComentarios}
        setModalActive={setModalActive}
        params={context.params}
        patern={context.paternSlug}
        paternTitle={context.titlePatern}
        title={context.params.titulo}
        granPatern={context.grandPaternSlug}
      />
    </div>
  )
}

export default ProductContent
